<template>
  <v-expansion-panels
    v-bind="$attrs"
    v-on="$listeners"
    v-model="expandedPanelIndex"
    v-if="items.length > 0"
    :accordion="accordion"
    :focusable="focusable"
  >
    <v-expansion-panel
      v-for="(item,i) in items"
      :key="i"
    >
      <v-expansion-panel-header
        class="panel"
        :class="item.headerClass"
        :aria-expanded="getExpandStatus(i)"
      >
        <slot
          :name="'header'+ (item.id ? item.id : i+1)"
        >
          <span
            class="panel--icon"
            v-if="item.icon"
          >
            <v-icon
              size="24"
              class="pr-4 material-icons-outlined"
            >
              {{ item.icon }}
            </v-icon>
          </span>
          <span
            class="subtitle-1"
            v-html="item.title ? item.title : ''"
          />
        </slot>
      </v-expansion-panel-header>
      <v-expansion-panel-content
        :class="item.contentClass"
      >
        <slot
          :name="'content'+ (item.id ? item.id : i+1)"
        >
          <span
            class="panelContent body-1"
            v-html="item.content"
          />
        </slot>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
const arraysEqual = (a1, a2) => {
  return a1.length === a2.length && a1.every(v => a2.indexOf(v) !== -1);
}

export default {
  name: 'AdsExpansionPanel',
  props: {
    accordion: {
      type: Boolean,
      default: true   // override the default value 'false' in v-expansion-panels
    },
    focusable: {
      type: Boolean,
      default: true   // override the default value 'false' in v-expansion-panels
    },
    value: {
      type: [Array, Number],
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expandedPanelIndex: [...this.value]
    }
  },
  watch: {
    value(val) {
      if (Array.isArray(val) && !arraysEqual(val, this.expandedPanelIndex)) {
        // sync external changes
        this.expandedPanelIndex = val;
      }
    },
    expandedPanelIndex(val) {
      if (Array.isArray(val) && !arraysEqual(val, this.value)) {
        // emit internal changes
        this.$emit('input', val);
      }
    }
  },
  methods: {
    getExpandStatus(index) {
      if (this.expandedPanelIndex && this.expandedPanelIndex.length > 0) {
        return this.expandedPanelIndex.indexOf(index) > -1 ? 'true' : 'false';
      }
      return 'false';
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';

.panel--icon {
  max-width: 40px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}

.panel {
  line-height: 24px;
  padding: 22px 28px;
}

.panelContent {
  padding: 22px 24px 18px;
  display: block;
  word-break: break-word;
}

.theme--dark {
  .v-expansion-panels .v-expansion-panel .subtitle-1, .panel--icon .v-icon {
    color: $ads-navy-dark !important;
  }

  ::v-deep .v-icon {
    color: $ads-navy-dark !important;
  }
}

// v-expansion-panel a11y focus state update
.theme--light {
  .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus {
    ::v-deep .v-expansion-panel-header__icon {
      border: 2px solid $ads-navy;
      border-radius: 50%;
    }
  }
}
.theme--dark {
  .v-expansion-panel-header:not(.v-expansion-panel-header--mousedown):focus {
    ::v-deep .v-expansion-panel-header__icon {
      border: 2px solid $ads-navy-dark;
      border-radius: 50%;
    }
  }
}
</style>
